import { createSlice } from "@reduxjs/toolkit";
import { ISelectOption } from "src/@types/form";
import { getInvestmentsReducer } from "./reducers";
import { INVESTMENTS_SLICE_NAME } from "./actions";

export interface IInvestmentsState {
  isLoading: boolean;
  data: ISelectOption[];
}

const initialState: IInvestmentsState = {
  isLoading: false,
  data: [],
};

export const { reducer: investments } = createSlice({
  name: INVESTMENTS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getInvestmentsReducer(builder);
  },
});
